import ErrorBoundary from "@/components/shared/ErrorBoundary";
import StatisterTab from "@/components/project/StatisterTab";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";

export default function StatisterPage() {
  const { project, invoices, budgetLines } = useProjectDetailContext();
  return (
    <ErrorBoundary>
      <StatisterTab
        projectId={project.id}
        projectCode={project.project_code}
        invoices={invoices}
        budgetLines={budgetLines}
      />
    </ErrorBoundary>
  );
}
